import { HexalInstance } from '@common/enums';
import { IMessage, MessageType, Modals } from '@common/types';
import { MarkdownRenderer } from '@components/markdown-renderer';
import { Button } from '@components/ui/button';
import useIsMobile from '@hooks/use-is-mobile';
import { cn, CURRENT_INSTANCE } from '@lib/utils';
import { useTranslation } from 'react-i18next';
import AnswerMessageContainer from './answer-message-container';

interface ISimpleMessageResponseProps {
  message?: IMessage;
  showModal?: (type: Modals, userQuery?: string) => void;
  userQuery?: string;
}

function SimpleResponse(props: ISimpleMessageResponseProps) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (!props.message?.message) return null;

  return (
    <AnswerMessageContainer>
      <MarkdownRenderer content={props.message?.message} />
      {props.message.type === MessageType.DisabledTopicMessage && props.showModal && (
        <Button
          className={cn(
            'bg-xircle-secondary mt-4 w-full sm:w-auto follow-up-buttons',
            CURRENT_INSTANCE.name === HexalInstance.Default &&
              'text-hexal-dark-text-color hover:text-slate-200'
          )}
          size={isMobile ? 'sm' : 'default'}
          onClick={() => props.showModal?.(Modals.MedicalInfo, props.userQuery)}
        >
          {t('chat.info_service')}
        </Button>
      )}
    </AnswerMessageContainer>
  );
}

export default SimpleResponse;
